import Phaser from "phaser";

export default class PotCounter extends Phaser.GameObjects.Container {
    constructor(scene, x, y, scale, gameData) {
        // Call the parent class (Phaser.GameObjects.Text) constructor
        super(scene, x, y);   
        // Add this text object to the scene
        scene.add.existing(this);

        this.gameData = gameData;
        this.currentAmount = 0;

         // Obtain the screen width and height
         const screenWidth = scene.sys.game.config.width;
         const screenHeight = scene.sys.game.config.height;
         
         // Calculate the center of the screen
         const centerX = screenWidth / 2;
         const centerY = screenHeight / 2;
        
        const wagerType = this.gameData.matchInfo.wagerType;
        const coinImage = wagerType === 'bonez' ? 'zoombies_bonez' : 'zoombies_chipz';

        // Check if the game is running on a desktop or a mobile device
        const isMobile = scene.sys.game.device.os.desktop ? false : true;

        let coinPosX, coinPosY, counterPosX, counterPosY, coinScale, bonezScale, textScale;

        if (isMobile) {
            coinPosX = centerX - (this.scale * 1420);
            coinPosY = centerY - (this.scale * 440);
            counterPosX = centerX - (this.scale * 1330);
            counterPosY = centerY - (this.scale * 490);
            coinScale = this.scale * 0.8;
            bonezScale = this.scale * 0.32;
            textScale = this.scale * 100;
        } else {
            coinPosX = centerX - (this.scale * 2150); 
            coinPosY = centerY - (this.scale * 810);   
            counterPosX = centerX - (this.scale * 2010); 
            counterPosY = centerY - (this.scale * 880);
            coinScale = this.scale * 1.2;
            bonezScale = this.scale * 0.32;
            textScale = this.scale * 150;
        }

        // Add the coin image
        this.coinSprite = new Phaser.GameObjects.Image(scene, coinPosX, coinPosY, coinImage).setScale(wagerType === 'bonez' ? bonezScale : coinScale);
        this.add(this.coinSprite);

        // Add the text
        this.counterText = new Phaser.GameObjects.Text(scene, counterPosX, counterPosY, '0', { fontSize: textScale + "px", fontFamily: "TruculentaBold", fill: '#B2F1FF' });
        this.add(this.counterText);
    }

    startCounting() {
        let totalPot = this.gameData.matchInfo.potAmount - this.gameData.matchInfo.tableFee;
    
        // Increment value: Increase by 10 (or any other value you prefer)
        let incrementValue = Math.ceil((totalPot - this.currentAmount) * 0.008); 
        if (incrementValue < 1) incrementValue = 1; // Ensure we always increase by at least 1
    
        if (this.currentAmount < totalPot) {
            this.currentAmount += incrementValue;
            if (this.currentAmount > totalPot) this.currentAmount = totalPot; // Ensure we don't exceed the totalPot value
            
            this.counterText.setText(this.currentAmount.toLocaleString());
        
            // Delay: 10ms for smoother animation (you can adjust this value to your liking)
            this.scene.time.delayedCall(10, this.startCounting, [], this);
        }
    }
}